export enum CurrencyId {
  Czk = 1,
  Eur = 2,
  Gbp = 3,
  Usd = 4,
}
export const FallbackCurrencyId = CurrencyId.Czk;

export const CurrencyId2CurrencyNameMap: Record<CurrencyId, string> = {
  [CurrencyId.Czk]: "Kč - Koruna česká",
  [CurrencyId.Eur]: "€ - Euro",
  [CurrencyId.Gbp]: "£ - British pound",
  [CurrencyId.Usd]: "$ - United States dollar",
};

export type Currency = {
  id: CurrencyId;
  code: string;
  symbol: string;
  isPositionLeft: boolean;
  isSpaceSeparator: boolean;
  decimalPrecisionWhenCurrencySwitch: number;
  decimalSeparator: string;
  thousandsSeparator: string;
  isAvailableForSwitchSelector: boolean;
  ratioThousands: { [currencyId: number]: number };
};
